import script from "./bi-tmpl-project.vue?vue&type=script&lang=tsx&setup=true"
export * from "./bi-tmpl-project.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__